module.exports = __webpack_public_path__ + "static/media/telas-info.f4dcf520.png";